"use client";

import { trackAppRouter } from "@socialgouv/matomo-next";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";

type GlobalAnalyticsProps = {
  matomoUrl: string;
  matomoSiteId: string;
};

function GlobalAnalytics({ matomoUrl, matomoSiteId }: GlobalAnalyticsProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    trackAppRouter({
      url: matomoUrl,
      siteId: matomoSiteId,
      pathname,
      searchParams,
    });
  }, [matomoSiteId, matomoUrl, pathname, searchParams]);

  return null;
}

export { GlobalAnalytics };
